import classNames from 'classnames';
import cs from '../application-details.module.scss';
import { fontStyles, TextField } from '@monash/portal-react';
import { Controller } from 'react-hook-form';

const AdditionalInfoField = () => {
  return (
    <div className={cs.fieldWrapper}>
      <div
        className={classNames(
          fontStyles.heading,
          fontStyles.sm,
          fontStyles.medium
        )}
      >
        Other Preferences
      </div>
      <Controller
        name="additionalInfo"
        render={({ field: { value, onChange, onBlur } }) => (
          <TextField
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            placeholder="Any additional information or preferences"
            multiline
            height="12rem"
          />
        )}
      />
    </div>
  );
};

export default AdditionalInfoField;
